import axios from "."

export default {
    getPackage,
}

async function getPackage(userId,packageId) {
  const response = await axios.get(`face2face-package/get_package_by_user_id_and_package_id?user_id=${userId}&package_id=${packageId}`)

  return response.data
}
